import React from "react";
import {Dialog} from "src/components/dialogs/Dialog"
import { css } from "aphrodite-jss";
import { styles } from "src/components/dialogs/PublicationSourceDialogStyle";
import { HorizontalBarChart} from "src/components/charts/HorizontalBarChart";
import { ChartItem } from "src/models/ChartItem";
import { appStore } from "src/mobx/AppStore";
import { RequestState } from "src/models/RequestState";

interface IPublicationSourceDialogProps {
    isOpen: boolean;
    onClose: any;
}

export class PublicationSourceDialog extends React.Component<IPublicationSourceDialogProps> {
    
    public static defaultProps = {
        isOpen: false,
        onClose: ()=>{},
    };

    public render() {
        let content;
        if(!this.props.isOpen){
            content = (
                <div>
                    
                </div>
            );
        }else{

            const selectedYear = appStore.facultyPageStore.authorPageData.selectedYear;
            let journalLabel;
            let journalToolTip;
            let journalState;
            
            if(selectedYear === 0){
                journalLabel = "Publications by Source";
                journalToolTip = "2008 -present (as reported on scopus.com)";
                journalState = RequestState.SUCCESS;
            }else{
                journalLabel = `Publications by Source for Year: ${selectedYear}`
                journalToolTip = `For: ${selectedYear} (as reported on scopus.com)`;
                journalState = appStore.facultyPageStore.authorPageData.requestState;
            }

            let publicationData; 
            if(selectedYear === 0) {
                publicationData = appStore.facultyPageStore.authorPageData.publicationData;
            }else if(appStore.facultyPageStore.authorPageData.requestState === RequestState.SUCCESS) {
                publicationData = appStore.facultyPageStore.authorPageData.filteredPublicationData;
            }else{
                publicationData = appStore.facultyPageStore.authorPageData.filteredPublicationData;
            }
                
            content = (
                    <HorizontalBarChart id="journal"
                        data={publicationData.publications_by_journal}
                        title={journalLabel}
                        tooltip={journalToolTip}
                        labelName={"Source"}
                        valueLabel={"Num of Pubs"}
                        tickCutOff={40}
                        yAxisWidth={200}
                    />
            )

        }
        

        return (
            <Dialog isOpen={this.props.isOpen} onClose={this.props.onClose} > 
                <div id="container" className={css(styles.container)}>
                    <React.Fragment>
                        {content}
                    </React.Fragment>
                </div>
            </Dialog>
        );
    }
    
}


// WEBPACK FOOTER //
// ./src/components/dialogs/PublicationSourceDialog.tsx